<header class="page-header">
    <div class="page-header__top">
        <div>
            <h1>Admin</h1>
            <p class="subtitle">Every admin section your role can reach.</p>
        </div>
    </div>
</header>

<admin-nav *ngIf="navEnabled"></admin-nav>

<div *ngIf="false" style="height: 95vh; overflow-y: scroll;">
    <table>
        <thead>
            <th>Service name</th>
            <!-- <th>Service name</th> -->
            <th>Last time</th>
            <th>time to alert (Sec)</th>
        </thead>
        <tbody>
            <tr *ngFor="let item of serverDashboard.serviceLastTimeSuccess | keyvalue" [ngClass]="{red: isTimeError(item.value)}">
                <td>{{item.value.name}}</td>
                <!-- <td>{{item.serverName}}</td> -->
                <td>{{item.value.lastTime | date: 'MM/dd/YYYY HH:mm:ss'}}</td>
                <td >{{item.value.timeForAlert / 1000}}</td>
            </tr>
        </tbody>
    </table>
    
    <h4 style="margin-top: 20px;">
        Push To PCC
    </h4>
    <ngx-pcc-dashboard #pcc ></ngx-pcc-dashboard>
    
    <div style="position: absolute; left: 50%; margin-top: -150px; margin-left: -150px; background-color: red; width: 300px; height: 300px;" *ngIf="showAlert" ></div>
    
</div>


<!-- <audio #alarm>
    <source src="assets/sounds/mixkit-classic-alarm-995.mp3" type="audio/ogg">
</audio> -->
  

<!-- <iframe src="assets/sounds/mixkit-classic-alarm-995.mp3" allow="autoplay" style="display:none" id="iframeAudio"> -->
<!-- </iframe>  -->



<!-- <table style="width: 1000px;">
    <thead>
        <th>Name</th>
        <th>ReferralID</th>
        <th>Navi Last Time Update</th>
        <th>Server last time</th>
        <th>Status</th>
    </thead>
    <tbody>
        <tr *ngFor="let item of initArray()">
            <td>{{item.PatientName}}</td>
            <td>{{item.ReferralID}}</td>
            <td>{{item.lastUpdateTime | date: 'MM/dd/YYYY HH:mm'}}</td>
            <td>{{item.serverLastUpdateTime | date: 'MM/dd/YYYY HH:mm'}}</td>
            <td [class]="item.status?.split(' ')[0]">{{item.status}}</td>
        </tr>
    </tbody>
</table> -->
